import { Controller } from '@nestjs/common';

@Controller('leave-approval')
export class LeaveApprovalController {}
